// removed by extract-text-webpack-plugin
module.exports = {"Header":"src-components-header----header-module---Header---v-bMc","spinAround":"src-components-header----header-module---spinAround---2u2QS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.module.scss
// module id = 218
// module chunks = 114276838955818 184470312924441